export default __webpack_public_path__ + "static/media/5d.03957d7c.svg";